import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { ConfigItem } from '@Types/index';

import { getHomeIcon, getCheckIcon, getDivider } from './utils';
import styles from './apps-popover-content.module.css';

interface AppsPopoverContentProps {
  configItems: Array<ConfigItem>;
}

const AppsPopoverContent: React.FC<AppsPopoverContentProps> = ({
  configItems,
}) => {
  return (
    <div className={styles.wrapper}>
      {configItems?.map((item) => {
        const linkContentClassName = classNames(
          styles.item,
          item.selected ? 'selected' : null
        );
        const homeIcon = getHomeIcon(item.title, item.selected);
        const checkIcon = getCheckIcon(item.selected);
        const divider = getDivider(item.title);

        const linkLeftSide = (
          <span className={styles.itemLeftSide}>
            {homeIcon}
            {item.title}
          </span>
        );
        const linkContent = (
          <div className={linkContentClassName}>
            {linkLeftSide}
            {checkIcon}
          </div>
        );

        if (item.onClick) {
          return (
            <div
              className={styles.itemWithOnClick}
              key={item.title}
              onClick={item.onClick}
            >
              {linkContent}
              {divider}
            </div>
          );
        }

        return (
          <Link key={item.title} to={item.link}>
            {linkContent}
            {divider}
          </Link>
        );
      })}
    </div>
  );
};

export default AppsPopoverContent;
